import { render, staticRenderFns } from "./MeetYourSideKick.vue?vue&type=template&id=ca080936&"
import script from "./MeetYourSideKick.vue?vue&type=script&lang=js&"
export * from "./MeetYourSideKick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports